import React from 'react';

import { Icons } from '@icons/icons';

import styles from './ImportedGoldenSettingsFile.module.scss';

interface ImportedGoldenSettingsFileProps {
	removeHandler: () => void;
	fileName: string;
}

const ImportedGoldenSettingsFile = ({
	removeHandler,
	fileName,
}: ImportedGoldenSettingsFileProps) => {
	return (
		<div className={styles.fileWrapper}>
			<span className={styles.fileIcon}>
				{Icons.fileIcon()}
			</span>
			<span className={styles.fileName}>
				{fileName}
			</span>
			<span
				className={styles.actionsWrapper}
				onClick={removeHandler}
			>
				{Icons.delete()}
			</span>
		</div>
	);
};

export default ImportedGoldenSettingsFile;
